import React, { Fragment } from 'react';
import { SelectableListItem, SelectItemWrapper, SelectItem, StyledCheck } from '../Components';
import { ClearFilter } from './ClearFilter';
const SelectList = ({ items, getItemProps, selectedItem, showClearButton, highlightedIndex }) => {
    return (React.createElement(Fragment, null,
        selectedItem && showClearButton && (React.createElement(ClearFilter, { getItemProps: getItemProps })),
        items.map((item, index) => {
            const active = selectedItem && selectedItem === item;
            const itemIndex = showClearButton ? index + 1 : index;
            return (React.createElement(SelectableListItem, Object.assign({ type: "button", key: itemIndex, isHighlighted: highlightedIndex === itemIndex }, item.props, getItemProps({
                item,
                index: itemIndex
            })),
                React.createElement(SelectItemWrapper, null,
                    React.createElement(SelectItem, null, item.text || item.value)),
                active && React.createElement(StyledCheck, null)));
        })));
};
export default SelectList;
//# sourceMappingURL=SelectList.js.map